const paymentFrequency = [{
  periodo: 'anual',
  pagos: 1
},
{
  periodo: 'semestral',
  pagos: 2
},
{
  periodo: 'trimestral',
  pagos: 4
},
{
  periodo: 'mensual',
  pagos: 12
}
]

export default paymentFrequency



// WEBPACK FOOTER //
// ./src/interfaces/paymentFrequency.js